import MenuItem from '@mui/material/MenuItem'
import { FC, useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { FixedRoute, Supplier } from '../../../../api/supplier/suppliers.types'
import { suppliersAPI } from '../../../../api/supplier/suppliersAPI'
import FormSelect from '../../../FormFields/Select/FormSelect'

interface Item {
  value: string | number
  label: string
}
const FixedRouteSelect: FC = () => {
  const [options, setOptions] = useState<Array<Item>>([])
  const supplier: Supplier = useSelector(
    (state: any) => state.suppliers.supplier,
  )
  const fixedRoutesResponse = useQuery({
    queryKey: ['getSupplierFixedRoutes', supplier.id],
    queryFn: async () => suppliersAPI.getSupplierFixedRoutes(supplier.id),
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (fixedRoutesResponse) {
      let options: Item[] = []
      fixedRoutesResponse?.data?.data.value.map((fixedRoute: FixedRoute) => {
        options.push({
          value: fixedRoute.id || 0,
          label: fixedRoute.name,
        })
      })
      setOptions(options)
    }
  }, [fixedRoutesResponse])

  console.log('taxi options', fixedRoutesResponse)
  return (
    <FormSelect
      name="fixedRouteId"
      placeholder="Fixed route"
      label="Fixed route"
    >
      {options.map((option) => {
        return (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        )
      })}
    </FormSelect>
  )
}

export default FixedRouteSelect
